import PropTypes from 'prop-types';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const WorkflowLink = ({
  emailSubject,
  portalId,
  workflowId
}) => {
  const workflowHref = `/workflows/${portalId}/platform/flow/${workflowId}/edit/`;
  return /*#__PURE__*/_jsx(Link, {
    href: workflowHref,
    target: "_blank",
    children: emailSubject
  });
};
WorkflowLink.propTypes = {
  emailSubject: PropTypes.string.isRequired,
  portalId: PropTypes.number.isRequired,
  workflowId: PropTypes.number.isRequired
};
WorkflowLink.displayName = 'WorkflowLink';
export default WorkflowLink;